<script lang="ts" setup>
defineProps<{ status?: boolean; role?: string }>()
</script>

<template>
  <div
    :aria-busy="status"
    aria-valuetext="Loading.."
    :role="status ? 'progressbar' : role"
    class="rounded-md bg-linear-to-r transition-colors duration-500"
    :class="{
      'animate-pulse from-background-gray-sunken via-background-gray-subtlest to-background-gray-sunken':
        status,
      'from-background-transparent via-background-transparent to-background-transparent': !status,
    }"
  >
    <slot />
  </div>
</template>
